<script lang="ts">
	import type { MeetingMinute } from '$lib/types/meeting';
	import { page } from '$app/stores';

	export let yearlyMinutes: Record<string, MeetingMinute[]>;

	$: currentYear = $page.params.year;
	$: years = Object.keys(yearlyMinutes).sort((a, b) => parseInt(b) - parseInt(a));
</script>

<nav
	class="rounded-lg bg-white p-6 shadow-md dark:bg-gray-800"
	aria-label="Browse meetings by year"
>
	<h3 class="mb-4 text-lg font-semibold text-gray-900 dark:text-white">Browse by Year</h3>

	<div class="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6">
		{#each years as year}
			{@const meetingCount = yearlyMinutes[year].length}
			<a
				href="/meetings/{year}"
				class="flex flex-col items-center rounded-lg p-3 transition-colors {currentYear === year
					? 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300'
					: 'text-gray-900 hover:bg-gray-50 dark:text-white dark:hover:bg-gray-700'}"
				aria-current={currentYear === year ? 'page' : undefined}
			>
				<span class="text-lg font-semibold">{year}</span>
				<span class="text-xs opacity-75">
					{meetingCount} meeting{meetingCount !== 1 ? 's' : ''}
				</span>
			</a>
		{/each}
	</div>

	{#if years.length === 0}
		<p class="py-4 text-center text-gray-500 dark:text-gray-400">No meetings available yet.</p>
	{/if}
</nav>
